export default __webpack_public_path__ + "static/media/coupon.b447c736.svg";